<mat-nav-list>
    <mat-list-item routerLinkActive="activo" [routerLink]="['/contratista/estado']" >
      <img src="../../../../assets/estados.svg" />
      Entidades/ Estado
    </mat-list-item>
    <mat-list-item routerLinkActive="activo"  [routerLink]="['/contratista/licencias']">
      <img src="../../../../assets/facturacion.svg" />
      <span matBadge="{{licenciasActivas}}" matBadgeOverlap="false" matBadgeColor="warn">Licencias</span>
      
    </mat-list-item>
    <mat-list-item routerLinkActive="activo"  [routerLink]="['/contratista/invitaciones']">
      <img src="../../../../assets/grupo.svg" />
      <span matBadge="{{facturas}}" matBadgeOverlap="false" style="margin-left: -0.5rem;" >Invitaciones</span>
      
    </mat-list-item>
    <mat-list-item routerLinkActive="activo"  [routerLink]="['/contratista/facturas']">
      <img src="../../../../assets/facturacion.svg" />
      <span>Facturas</span>
      
    </mat-list-item>
  </mat-nav-list>